import { render, staticRenderFns } from "./wechatLogin.vue?vue&type=template&id=ef6dd782&scoped=true"
import script from "./wechatLogin.vue?vue&type=script&lang=js"
export * from "./wechatLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef6dd782",
  null
  
)

export default component.exports